import axios, { AxiosResponse } from 'axios';
import { EStavLeiPlatby } from 'types/leiTypes';

export interface IPlatbaLogin {
    idzadosti: number;
    token: string;
    mena: string;
    castka: string;
    stavplatby: EStavLeiPlatby;
    varsymbol: string;
    lang: 'cz' | 'en';
    jinastranka: boolean;
}

export const platbaLogin = (token: string) => {
    return axios({
        method: 'POST',
        url: 'LEI/Platba',
        data: {
            // eslint-disable-next-line camelcase
            navrattoken: token
        }
    }).then((resp: AxiosResponse<IPlatbaLogin>) => resp.data);
};

export const stahnoutFakturu = (varsym: string, nazev: string) => {
    return axios({
        method: 'GET',
        url: 'LEI/Download/Prepare/CDCP',
        params: {
            varsym: varsym,
            nazev: nazev
        }
    }).then(
        (
            resp: AxiosResponse<{
                redirect: string;
            }>
        ) => resp.data
    );
};
